import { render, staticRenderFns } from "./ServiceWorkflow.vue?vue&type=template&id=664910a3&scoped=true"
import script from "./ServiceWorkflow.vue?vue&type=script&lang=js"
export * from "./ServiceWorkflow.vue?vue&type=script&lang=js"
import style0 from "./ServiceWorkflow.vue?vue&type=style&index=0&id=664910a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664910a3",
  null
  
)

export default component.exports